export default "__VITE_ASSET__DDY1HIxh__"